let activePlaceId: string | null = null;

export function getActivePlaceId(): string | null {
  return activePlaceId;
}

export function setActivePlaceId(placeId: string | null): void {
  activePlaceId = placeId;
}
